import { Box, styled } from "@mui/material";

export const PdfContainer = styled("div")({
  width: "100%",
  height: "100%",
  background: "#F2F4F7",
  padding: "12px",
});

export const PreviewTitle = styled("div")({
  color: "#667085",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  textAlign: "left",
  marginBottom: "10px",
});

export const LoadingField = styled(Box)({
  height: "300px",
});

export const PDFField = styled("div")({
  width: "100%",
  height: "380px",
  overflow: "auto",
});
